import { render, staticRenderFns } from "./TheFundTransfer.vue?vue&type=template&id=2bdb81a1&"
import script from "./TheFundTransfer.vue?vue&type=script&lang=js&"
export * from "./TheFundTransfer.vue?vue&type=script&lang=js&"
import style0 from "./TheFundTransfer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports